import styled from '@emotion/styled'
import {theme} from '../../../../../../core/theme'
// ── Styled components ─────────────────────────────────────────────────────────

export const TabPanel = styled.header`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  width: 100%;
  background: linear-gradient(0deg, #ffffff 54.97%, #f5f7ff 89.27%);
  padding: 0 10px;
  border-radius: 12px;
  flex-wrap: wrap;
`

// ── Right side actions ────────────────────────────────────────────────────

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  //   flex-shrink: 0;
`
